import { getInvisibleSpace } from "../getInvisibleSpace";
export function getPagesCount(calcs) {
    let counter = 0;
    if (calcs.step) {
        counter = Math.ceil(getInvisibleSpace(calcs) / calcs.step) + 1;
    }
    return counter;
}
//# sourceMappingURL=getPagesCount.js.map